import React from 'react';
import { Category } from 'spw-redux/modules/space_types/types';
import { Grid, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { projectColors as selectProjectColors } from 'spw-redux/modules/projects/selectors';
import { ColorDot } from 'spw-esa-projects/building-details/occupancy-and-utilization/styles';

type Props = {
  categories: Category[];
};
const CategoryDotSection = ({ categories }: Props) => {
  const projectColors = useSelector(selectProjectColors);

  return (
    <Grid container>
      {categories.map((category) => (
        <Grid item xs={3} key={category}>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            height="100%"
            style={{ height: 24 }}
          >
            <ColorDot
              key={category}
              color={projectColors[category] as string}
            />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default CategoryDotSection;
